// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"535": "__federation_expose_VoiceCommandSettings","542": "__federation_expose_AssistantDock",}[chunkId] + "." + {"535": "3b05e2bc","542": "57aaf79a",}[chunkId] + ".css"
}